import Mark from './Mark.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'mark', Mark);
  },
};
